import { SxProps } from "@mui/material";

export const filterButtonsContainerSx: SxProps = {
  display: "flex",
  justifyContent: "space-between",
};
